const inkeep_ai_bot = {
    intro_message: 'Olá, sou o Logto AI!\n\nSou um assistente de IA treinado em documentação, artigos de ajuda e outros conteúdos.\n\nPergunta-me qualquer coisa sobre o `Logto`.',
    chat_placeholder: 'Faça a sua pergunta ao Logto AI para um guia passo a passo',
    disclaimer_label: 'Aviso de Logto AI',
    disclaimer_tooltip: 'As respostas são geradas por IA e podem necessitar de verificação.',
    example_questions_label: 'Questões exemplo',
    example_questions: [
        'Guia de iniciação para a configuração do Logto',
        'Configurar arquitetura multi-inquilino',
        'Como integrar o perfil do utilizador?',
    ],
    stop: 'Parar',
    clear: 'Recomeçar',
    get_help: 'Obter ajuda',
    copy_chat: 'Copiar',
    ask_ai_label: 'Perguntar à IA',
    contact: 'Contacto',
    discord: 'Discord',
};
export default Object.freeze(inkeep_ai_bot);
